import styled from 'styled-components';
import {
  BaseListContainer,
  commonTableStyles
} from '../shared/SharedListStyles';

export const Container = styled(BaseListContainer)`
  width: 380px;
  min-width: 380px;
  max-width: 380px;
  padding-top: 5px;
  form > div {
    width: 350px;
  }
  .equipment-list-table {
    ${commonTableStyles}
  }
`;
